import { observer } from "mobx-react-lite";
import React from "react";
import { Switch } from "antd";
import { t } from "i18next";
import { EntityFiltersPageStore } from "../../EntityFiltersPageStore";
import styles from "./FilterSwitch.module.less";

interface FilterSwitchProps {
  store: EntityFiltersPageStore;
}

export const FilterSwitch: React.FC<FilterSwitchProps> = observer(
  ({ store }) => (
    <label className={styles.container}>
      <Switch
        onChange={(checked) => store.setSiderVisible(checked)}
        value={store.siderVisible}
      />
      {t("Show filter")}
    </label>
  ),
);
